document.addEventListener("DOMContentLoaded", () => {
  const params = new URLSearchParams(window.location.search);
  const root = document.querySelector("[data-inquiry-context]");
  const contactForm = document.querySelector("#ContactForm");
  const quickMatch = document.querySelector("[data-quick-match]");
  const applicationInput = quickMatch?.querySelector("[data-application-input]");
  const applicationCards = document.querySelectorAll("[data-application-card]");
  const revealNodes = document.querySelectorAll("[data-reveal]");

  if ("IntersectionObserver" in window) {
    const revealObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.18 }
    );

    revealNodes.forEach((node) => revealObserver.observe(node));
  } else {
    revealNodes.forEach((node) => node.classList.add("is-visible"));
  }

  if (applicationInput instanceof HTMLSelectElement) {
    applicationCards.forEach((card) => {
      card.addEventListener("click", () => {
        const nextValue = card.getAttribute("data-application-value") ?? "";
        applicationInput.value = nextValue;
        applicationCards.forEach((item) => item.removeAttribute("data-selected"));
        card.setAttribute("data-selected", "true");
      });
    });
  }

  if (quickMatch instanceof HTMLFormElement) {
    quickMatch.addEventListener("submit", () => {
      quickMatch.setAttribute("data-submitting", "true");
    });
  }

  if (contactForm instanceof HTMLFormElement) {
    const phoneNumberInput = contactForm.querySelector("[data-phone-number]");
    const countryInput = contactForm.querySelector("#ContactFormCountry");
    const productInterestInput = contactForm.querySelector("#ContactFormProductInterest");
    const messageInput = contactForm.querySelector("[data-inquiry-message]");

    if (phoneNumberInput instanceof HTMLInputElement) {
      phoneNumberInput.setCustomValidity("");
    }

    const application = params.get("application")?.trim() ?? "";
    const sizeModel = params.get("size_model")?.trim() ?? "";
    const targetMarket = params.get("target_market")?.trim() ?? "";
    const demandNotes = params.get("demand_notes")?.trim() ?? "";
    const source = params.get("source")?.trim() ?? "";

    if (
      countryInput instanceof HTMLInputElement &&
      !countryInput.value.trim() &&
      targetMarket
    ) {
      countryInput.value = targetMarket;
    }

    if (
      productInterestInput instanceof HTMLSelectElement &&
      !productInterestInput.value &&
      application
    ) {
      const optionExists = Array.from(productInterestInput.options).some(
        (option) => option.value === application
      );

      if (optionExists) {
        productInterestInput.value = application;
      }
    }

    if (messageInput instanceof HTMLTextAreaElement && !messageInput.value.trim()) {
      const messageLines = [
        "Homepage quick match inquiry:",
        application ? `Application: ${application}` : "",
        sizeModel ? `Size / Model: ${sizeModel}` : "",
        targetMarket ? `Target Market: ${targetMarket}` : "",
        demandNotes ? `Quantity / Notes: ${demandNotes}` : "",
        source ? `Source: ${source}` : "",
        "",
        "Please share quotation, lead time, and application guidance."
      ].filter(Boolean);

      if (messageLines.length > 2) {
        messageInput.value = messageLines.join("\n");
      }
    }
  }

  if (!root) return;

  const entries = [
    ["product", params.get("product")],
    ["collection", params.get("collection")],
    ["article", params.get("article")],
    ["source", params.get("source")],
    ["application", params.get("application")],
    ["size_model", params.get("size_model")],
    ["target_market", params.get("target_market")],
    ["demand_notes", params.get("demand_notes")]
  ].filter(([, value]) => Boolean(value));

  if (entries.length === 0) return;

  const summary = entries
    .map(([key, value]) => {
      const formattedKey = String(key).replace(/[_-]+/g, " ");
      const formattedValue = String(value).replace(/[-_]+/g, " ");
      return `${formattedKey}: ${formattedValue}`;
    })
    .join(" | ");

  const summaryNode = root.querySelector("[data-inquiry-summary]");
  if (summaryNode) {
    summaryNode.textContent = `Inquiry context: ${summary}`;
    summaryNode.hidden = false;
  }

  const hiddenInput = root.querySelector("[data-inquiry-hidden]");
  if (hiddenInput instanceof HTMLInputElement) {
    hiddenInput.value = summary;
  }

  const messageInput = root.querySelector("[data-inquiry-message]");
  if (messageInput instanceof HTMLTextAreaElement && !messageInput.value.trim()) {
    messageInput.value = `Inquiry context: ${summary}\n\nPlease share quotation, lead time, and application guidance.`;
  }
});
